import { fromJS, Map, List } from 'immutable';

export function request(state) {
    return state
        .setIn([ 'create', 'state' ], 'IN_PROGRESS')
        .setIn([ 'create', 'errors' ], null)
        .setIn([ 'create', 'result' ], null);
}

export function error(state, { errors }) {
    return state
        .setIn([ 'create', 'state' ], 'ERROR')
        .setIn([ 'create', 'errors' ], fromJS(errors))
        .setIn([ 'create', 'result' ], null);
}

export function finish(state, { participant }) {
    return state
        .setIn([ 'create', 'state' ], 'FINISHED')
        .setIn([ 'create', 'errors' ], null)
        .setIn([ 'create', 'result' ], fromJS(participant));
}

export function clear(state) {
    return state
        .set('create', Map());
}
